<template>
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
        <el-tab-pane label="心理咨询面谈比赛" name="xlzx">
            <Consult ref="consult"></Consult>
        </el-tab-pane>
        <el-tab-pane label="教学技能比赛" name="jxjn">
            <Skill ref="skill"></Skill>
        </el-tab-pane>
        <el-tab-pane label="案例开发比赛" name="alkf">
            <Case ref="case"></Case>
        </el-tab-pane>
        <el-tab-pane label="心理科普微视频" name="xlkp">
            <Popularization ref="popularization"></Popularization>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
import Consult from '../ApplyMind/template/consult.vue';
import Case from '../ApplyMind/template/case.vue';
import Popularization from '../ApplyMind/template/popularization.vue';
import Skill from '../ApplyMind/template/skill.vue';

export default {
    mounted() {

    }, data() {
        var activeName = 'xlzx';
        return {
            activeName,
        }
    }, deactivated() {

    },
    components: {
        Consult,
        Case,
        Popularization,
        Skill,
    }
};

</script>
<style scoped>
:deep(.el-tabs__item:hover) {
    color: #409eff;
}

:deep(.el-tabs__item.is-active) {
    color: #409eff;
}

:deep(.el-tabs__active-bar) {
    background-color: #409eff;
}
</style>